import PropTypes from 'prop-types';

import { ContainerProps as MuiContainerProps } from '@mui/material/Container';
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { globalColours } from '@classity-edtech/ui-base/dist/style/source';
import { Button } from '@classity-edtech/ui-base';
import { FullLogo } from '@classity-edtech/ui-base/dist/components/Displays';

import { webPaths } from '../../routes/paths';
import GoogleButton from '../../components/GoogleButton';

export interface EducatorSigninProps extends MuiContainerProps {}

export const EducatorSignin = ({ className }: EducatorSigninProps) => {
  const navigate = useNavigate();
  const localisedMessage = (id: string) => {
    const F: any = FormattedMessage;
    return <F id={id} />;
  };

  return (
    <Box
      className={className}
      sx={{
        width: '100%',
        minHeight: '100dvh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          rowGap: 0,
          px: { xs: 2.5, md: 4 },
          width: '100%',
          maxWidth: '568px',
        }}
      >
        <Box sx={{ margin: '0 auto', width: 'fit-content' }}>
          <FullLogo
            sx={{
              height: { xs: '28px', md: '42px' },
              width: 'max-content',
              margin: { xs: '0 auto 48px', md: '0 auto 48px' },
              cursor: 'pointer',
            }}
            onClick={() => navigate('/')}
          />
        </Box>
        <Typography variant='subtitle3' sx={{ textAlign: 'center', mx: 'auto', display: 'block' }}>
          {localisedMessage('auth.signin.welcome.back')}
        </Typography>
        <Typography
          variant='body2'
          sx={theme => ({
            textAlign: 'center',
            color: globalColours['$global-colour-content-secondary'],
            mb: { xs: 3, md: 6 },
          })}
        >
          {localisedMessage('auth.signin.get.started')}
        </Typography>

        <GoogleButton text='signin_with' />
        <Box sx={{ mt: 2, textAlign: 'center' }}>
          <Typography variant='body3'>
            {localisedMessage('auth.signin.dont.have.account')}
          </Typography>{' '}
          <Button
            variant='text'
            sx={{ display: 'inline', p: 0, minWidth: 'fit-content' }}
            onClick={() => navigate(`/${webPaths.teachSignup}`)}
          >
            {localisedMessage('auth.signup')}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

EducatorSignin.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

EducatorSignin.defaultProps = {
  children: null,
  className: null,
};

export default styled<any>(EducatorSignin)(({ theme }) => ``);
